<template>
  <div>
      <div class="article-container">
        <div class="main-image"  v-bind:style="{ backgroundImage: 'url(' + post.image + ')' }">
        </div>
        <h1>{{post.name}}</h1>
        <div class="article-body" v-html="post.content">

        </div>
        <div class="article-body">

          <div v-if="post.wistia10">
            <p>Week 10</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia10" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed10" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia9">
            <p>Week 9</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia9" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed9" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia8">
            <p>Week 8</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia8" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed8" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia7">
            <p>Week 7</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia7" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed7" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia6">
            <p>Week 6</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia6" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed6" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia5">
            <p>Week 5</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia5" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed5" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia4">
            <p>Week 4</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia4" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed4" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia3">
            <p>Week 3</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia3" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed3" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia2">
            <p>Week 2</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div v-bind:class="'wistia_async_'+post.wistia2" class="wistia_embed  seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed2" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>

          <div v-if="post.wistia">
            <p>Week 1</p>
            <div  class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_k7ma2z47qz seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img v-bind:src="wistiaEmbed" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/></div></div></div></div>
          </div>
        </div>
      </div>
      <article-preview></article-preview>
  </div>
</template>

<script>
import ArticlePreview from './article-preview';
export default {
  name: 'article',
  components: {ArticlePreview},
  data () {
    return {
      post:{
        id:null,
        image:null,
      },
      wistiaJSONP:null,
      wistiaEmbed:null,
      wistiaScript:null,

      wistiaJSONP2:null,
      wistiaEmbed2:null,
      wistiaScript2:null,

      wistiaJSONP3:null,
      wistiaEmbed3:null,
      wistiaScript3:null,

      wistiaJSONP4:null,
      wistiaEmbed4:null,
      wistiaScript4:null,

      wistiaJSONP5:null,
      wistiaEmbed5:null,
      wistiaScript5:null,

      wistiaJSONP6:null,
      wistiaEmbed6:null,
      wistiaScript6:null,

      wistiaJSONP7:null,
      wistiaEmbed7:null,
      wistiaScript7:null,

      wistiaJSONP8:null,
      wistiaEmbed8:null,
      wistiaScript8:null,

      wistiaJSONP9:null,
      wistiaEmbed9:null,
      wistiaScript9:null,

      wistiaJSONP10:null,
      wistiaEmbed10:null,
      wistiaScript10:null,

      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    getPost: function(){
      var _this = this;
      if(_this.$route.params.id){
        console.log(_this.$route.params.id)
        var Post = Parse.Object.extend('Post');
        var post = new Post();
        post.id = _this.$route.params.id;
        post.fetch()
          .then(function(savedPost){
            console.log("SPOST");
            _this.post = {
              id:savedPost.id,
              previewText:savedPost.attributes.previewText,
              name:savedPost.attributes.name,
              image:savedPost.attributes.image,
              status:savedPost.attributes.status,
              content:savedPost.attributes.content,
              wistia:savedPost.attributes.wistia,
              wistia2:savedPost.attributes.wistia2,
              wistia3:savedPost.attributes.wistia3,
              wistia4:savedPost.attributes.wistia4,
              wistia5:savedPost.attributes.wistia5,
              wistia6:savedPost.attributes.wistia6,
              wistia7:savedPost.attributes.wistia7,
              wistia8:savedPost.attributes.wistia8,
              wistia9:savedPost.attributes.wistia9,
              wistia10:savedPost.attributes.wistia10,
            };
            if(savedPost.attributes.wistia){
              //Insert Wistia Script Tag
              _this.wistiaJSONP = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia+'.jsonp';
              _this.wistiaScript = document.createElement('script');
              _this.wistiaScript.setAttribute('src', _this.wistiaJSONP);
              document.head.appendChild(_this.wistiaScript);
              _this.wistiaEmbed = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia+'/swatch';
            }

            if(savedPost.attributes.wistia2){
              //Insert Wistia Script Tag
              _this.wistiaJSONP2 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia2+'.jsonp';
              _this.wistiaScript2 = document.createElement('script');
              _this.wistiaScript2.setAttribute('src', _this.wistiaJSONP2);
              document.head.appendChild(_this.wistiaScript2);
              _this.wistiaEmbed2 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia2+'/swatch';
            }

            if(savedPost.attributes.wistia3){
              //Insert Wistia Script Tag
              _this.wistiaJSONP3 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia3+'.jsonp';
              _this.wistiaScript3 = document.createElement('script');
              _this.wistiaScript3.setAttribute('src', _this.wistiaJSONP3);
              document.head.appendChild(_this.wistiaScript3);
              _this.wistiaEmbed3 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia3+'/swatch';
            }

            if(savedPost.attributes.wistia4){
              //Insert Wistia Script Tag
              _this.wistiaJSONP4 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia4+'.jsonp';
              _this.wistiaScript4 = document.createElement('script');
              _this.wistiaScript4.setAttribute('src', _this.wistiaJSONP4);
              document.head.appendChild(_this.wistiaScript4);
              _this.wistiaEmbed4 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia4+'/swatch';
            }

            if(savedPost.attributes.wistia5){
              //Insert Wistia Script Tag
              _this.wistiaJSONP5 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia5+'.jsonp';
              _this.wistiaScript5 = document.createElement('script');
              _this.wistiaScript5.setAttribute('src', _this.wistiaJSONP5);
              document.head.appendChild(_this.wistiaScript5);
              _this.wistiaEmbed5 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia5+'/swatch';
            }

            if(savedPost.attributes.wistia6){
              //Insert Wistia Script Tag
              _this.wistiaJSONP6 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia6+'.jsonp';
              _this.wistiaScript6 = document.createElement('script');
              _this.wistiaScript6.setAttribute('src', _this.wistiaJSONP6);
              document.head.appendChild(_this.wistiaScript6);
              _this.wistiaEmbed6 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia6+'/swatch';
            }

            if(savedPost.attributes.wistia7){
              //Insert Wistia Script Tag
              _this.wistiaJSONP7 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia7+'.jsonp';
              _this.wistiaScript7 = document.createElement('script');
              _this.wistiaScript7.setAttribute('src', _this.wistiaJSONP7);
              document.head.appendChild(_this.wistiaScript7);
              _this.wistiaEmbed7 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia7+'/swatch';
            }

            if(savedPost.attributes.wistia8){
              //Insert Wistia Script Tag
              _this.wistiaJSONP8 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia8+'.jsonp';
              _this.wistiaScript8 = document.createElement('script');
              _this.wistiaScript8.setAttribute('src', _this.wistiaJSONP8);
              document.head.appendChild(_this.wistiaScript8);
              _this.wistiaEmbed8 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia8+'/swatch';
            }

            if(savedPost.attributes.wistia9){
              //Insert Wistia Script Tag
              _this.wistiaJSONP9 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia9+'.jsonp';
              _this.wistiaScript9 = document.createElement('script');
              _this.wistiaScript9.setAttribute('src', _this.wistiaJSONP9);
              document.head.appendChild(_this.wistiaScript9);
              _this.wistiaEmbed9 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia9+'/swatch';
            }

            if(savedPost.attributes.wistia10){
              //Insert Wistia Script Tag
              _this.wistiaJSONP10 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia10+'.jsonp';
              _this.wistiaScript10 = document.createElement('script');
              _this.wistiaScript10.setAttribute('src', _this.wistiaJSONP10);
              document.head.appendChild(_this.wistiaScript10);
              _this.wistiaEmbed10 = 'https://fast.wistia.com/embed/medias/'+_this.post.wistia10+'/swatch';
            }


          })
          .catch(function(err){
            console.error(err);
            alert(err);
          });
       }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(to);
      console.log(from);
      if(this.wistiaScript){
        if(this.wistiaScript.parentNode) this.wistiaScript.parentNode.removeChild( this.wistiaScript );
      }
      this.getPost();
    }
  },
  mounted() {
    var user = Parse.User.current();
    if(!user){
       this.$router.push('/login');
       return
    }
    if(!user.get('programs')){
       this.$router.push('/dashboard/my-details');
       return
    }
    this.$nextTick(() => {
      this.getPost();
    });
  }
}
</script>

<style>
.article-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.article-container .main-image{
  height: 300px;
  background-size: cover;
}
.article-container h1 {
  width: 100%;
  text-align: left;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.article-body img {
  width: 100%;
}
</style>
